export const words=["As per section R308.4.2, Safety /Tempered glazing required adjacent to doors-24in"]